import configReducer from './config/reducer';
import questionReducer from './QuestionForm/reducer';
import scheduleListReducer from './Notification/scheduleList/reducer';

export default {
    questionSet: questionReducer,
    scheduleList: scheduleListReducer,
    config: configReducer
};
